import { Component, OnInit } from '@angular/core';
import { LoaderService } from '../../../service/loader.service';
import { ErrorPageService } from './error-page.service';


@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
})
export class ErrorPageComponent implements OnInit {
  data: Error | undefined;

  constructor(private errorPageService: ErrorPageService,
              private loaderService: LoaderService) {
  }

  ngOnInit(): void {
    this.loaderService.hide();
    this.data = this.errorPageService.getError();
    if (this.data) {
      this.data = this.errorPageService.getError();
    } else {
      this.errorPageService.setError({});
      this.data = this.errorPageService.getError();
    }
  }

  get message(): string {
    if (!!this.data) {
      return `Errore ${this.data.message}`;
    }
    return '';
  }

  reload(): void {
      window.location.href = '/';
  }
}
